import React from "react";

const GoogleIcon = ({ width = 20, height = 20 }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 533.5 544.3"
    >
      <path fill="#4285F4" d="M533.5 278.4c0-17.7-1.6-34.7-4.7-51H272v96.8h146.9c-6.3 33.6-25.1 62.2-53.6 81.4v67h86.7c50.7-46.8 81.5-115.7 81.5-194.2z"/>
      <path fill="#34A853" d="M272 544.3c72.7 0 133.7-24.1 178.3-65.4l-86.7-67c-24.1 16.2-55 25.7-91.6 25.7-70.4 0-130-47.6-151.2-111.5h-89.2v69.8c44.7 88 136.7 148.4 240.4 148.4z"/>
      <path fill="#FBBC05" d="M120.8 326.1c-10.5-31.6-10.5-65.7 0-97.3v-69.8h-89.2c-36.8 73.6-36.8 160.1 0 233.7l89.2-66.6z"/>
      <path fill="#EA4335" d="M272 107.7c39.5 0 75 13.6 103 40.4l77.1-77.1C405.7 24.6 344.7 0 272 0 168.3 0 76.3 60.4 31.6 148.4l89.2 69.8c21.1-63.9 80.7-111.5 151.2-111.5z"/>
    </svg>
  );
};

export default GoogleIcon;
